import React from 'react';
import LocalizedStrings from 'react-localization';
import { Chart } from 'react-google-charts';
import Widget from '../Widget/Widget.js';
import 'react-table/react-table.css'
import './GuageChartWidget.css';

class GuageChartWidget extends React.Component {

  constructor(props) {
    super(props);
    this.strings = new LocalizedStrings({
     en:{
       noData: 'No data available'
     },
     de: {
       noData: 'Keine Daten verfügbar'
     }
    });

    if(props.language) {
      this.strings.setLanguage(props.language);
    }
  }

  renderChart() {
    // if(this.props.search && this.props.search.rows && this.props.search.rows.length > 0) {
    //
    const height = 200;// (this.props.rowHeight*this.props.size.h) - 120;
    //
    const label = Object.keys(this.props.search.rows[0])[0];

    const data = [
      ['Label', 'Value'],
      [label, Number(this.props.search.rows[0][label])/1000]
    ];
    //
    const options = {
      height,
      redFrom: 0, redTo: 90,
      greenFrom: 90, greenTo: 100,
      minorTicks: 5, majorTicks: ['0', '10', '20', '30', '40', '50', '60', '70', '80', '90', '100']
    };
    //
    //   var chart = new google.visualization.Gauge(document.getElementById('chart_div'));
    //
    //   chart.draw(data, options);
    //
    //   console.log(this.props.search.rows);
    // } else {
    //   return (<h2 className="text-center">{ this.strings.noData }</h2>);
    // }
    return (
      <Chart
          chartType="Gauge"
          data={data}
          options={options}
        />
    );
  }

  render() {
    return (
      <Widget {...this.props}>
        <div className="row widget-fullheight-row">
          <div className="col align-self-center">
            <h1 className="text-center">{this.props.title} (000s)</h1>
            { this.renderChart() }
          </div>
        </div>
      </Widget>
    )

  }
}

export default GuageChartWidget;



// WEBPACK FOOTER //
// ./src/components/Dashboard/components/GuageChartWidget/GuageChartWidget.js